export const MAPCONTROL_NAME = "Coordinates";